import { Capacitor } from '@capacitor/core';

/**
 * Store and ad settings. Only PUBLIC identifiers belong in the app:
 * RevenueCat "public app-specific API keys" and AdMob ad unit ids are meant
 * to ship inside apps. Secret keys (RevenueCat secret key, App Store / Play
 * service credentials) live only in the RevenueCat dashboard.
 *
 * Values come from build-time environment variables (Codemagic → Environment
 * variables, or a local .env file which is not committed):
 *   VITE_REVENUECAT_IOS_KEY, VITE_REVENUECAT_ANDROID_KEY
 *   VITE_ADMOB_REWARDED_IOS, VITE_ADMOB_REWARDED_ANDROID
 * Without them the game runs in TEST MODE (fake purchase sheet, fake video).
 */
const env = import.meta.env as Record<string, string | undefined>;

export const platform = Capacitor.getPlatform() as 'ios' | 'android' | 'web';
export const isNative = Capacitor.isNativePlatform();

export const REVENUECAT_KEY = platform === 'ios' ? env.VITE_REVENUECAT_IOS_KEY : platform === 'android' ? env.VITE_REVENUECAT_ANDROID_KEY : undefined;

/** Google's official test ad units – used until real ones are configured. */
const TEST_REWARDED = { ios: 'ca-app-pub-3940256099942544/1712485313', android: 'ca-app-pub-3940256099942544/5224354917' };

export const ADMOB_REWARDED =
  platform === 'ios' ? env.VITE_ADMOB_REWARDED_IOS ?? TEST_REWARDED.ios
  : platform === 'android' ? env.VITE_ADMOB_REWARDED_ANDROID ?? TEST_REWARDED.android
  : undefined;
export const ADMOB_IS_TEST = !env.VITE_ADMOB_REWARDED_IOS && !env.VITE_ADMOB_REWARDED_ANDROID;

/** Real purchases need the native app and a RevenueCat key. */
export const purchasesAreReal = isNative && !!REVENUECAT_KEY;
export const adsAreReal = isNative;
